/* Studio hours helper (28 Sep): returns { label } while the studio is open, Monday to Saturday 09:00 to 18:00 India time, else null. */
window.kdStudioOpen = window.kdStudioOpen || function () {
  try {
    var o = {}, now = new Date();
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
      .formatToParts(now).forEach(function (x) { o[x.type] = x.value; });
    var m = (+o.hour) * 60 + (+o.minute);
    if (o.weekday === 'Sun' || m < 540 || m >= 1080) return null;
    var tz = 'Asia/Kolkata'; try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || tz; } catch (e) {}
    var label = 'Open now, until 18:00 India time';
    if (!/Kolkata|Calcutta/.test(tz)) {
      var close = new Date(now.getTime() + (1080 - m) * 60000);
      label += ' (' + close.toLocaleTimeString('en-GB', { timeZone: tz, hour: '2-digit', minute: '2-digit', hour12: false }) + ' your time)';
    }
    return { label: label };
  } catch (e) { return null; }
};

/* KUSHA Studio v3 extras: session gallery and healer choice. Works alongside kd-studio.js. No dependencies. */

/* Reveal backstop. kd-studio.js reveals blocks with an IntersectionObserver, but Chrome measures a block's visible
   area after its own clip-path, so a mask that starts fully clipped (.k3-mask) reads as 0% visible and never opens.
   Blocks that start hidden and are shown later (the next-open chip) can be missed too. This checks real geometry on
   scroll, resize and load, and opens anything on or above the screen. */
(function () {
  'use strict';
  var sel = '.kds-r:not(.is-in), [data-split]:not(.is-in)';
  var queued = false;
  var check = function () {
    queued = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (!r.width && !r.height) continue; /* not displayed yet (a closed tab or hidden chip) */
      if (r.top < vh * 0.94) els[i].classList.add('is-in');
    }
  };
  var queue = function () { if (!queued) { queued = true; (window.requestAnimationFrame || setTimeout)(check); } };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
  document.addEventListener('click', function () { setTimeout(queue, 60); }, true);
  if ('MutationObserver' in window) new MutationObserver(queue).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue); else queue();
  /* a last guard: if animation frames are paused, open everything above the fold after 2.5s */
  setTimeout(check, 2500);
})();

(function () {
  'use strict';
  var root = document.querySelector('.k3');
  if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  /* gallery: thumbnails switch the main image; slow auto advance while in view */
  $$('[data-k3-gal]').forEach(function (g) {
    var thumbs = $$('[data-k3-go]', g), slides = $$('.k3-gal__slide', g), cur = 0, timer = null, userTouched = false;
    if (slides.length < 2) return;
    var go = function (i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-on', j === cur); });
      thumbs.forEach(function (t, j) { t.setAttribute('aria-pressed', j === cur ? 'true' : 'false'); });
    };
    thumbs.forEach(function (t) { t.addEventListener('click', function () { userTouched = true; stop(); go(+t.getAttribute('data-k3-go')); }); });
    var start = function () { if (reduce || userTouched || timer) return; timer = setInterval(function () { go(cur + 1); }, 5200); };
    var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { if (es[0].isIntersecting) start(); else stop(); }, { threshold: 0.4 }).observe(g);
    /* swipe on touch */
    var x0 = null;
    g.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    g.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { userTouched = true; stop(); go(cur + (dx < 0 ? 1 : -1)); } x0 = null; }, { passive: true });
  });

  /* healer choice on the page carries into the booking drawer */
  var who = root.querySelector('[data-k3-who]');
  if (who) {
    var opts = $$('.k3-who__opt', who), mode = 'team';
    var priceEl = root.querySelector('[data-k3-price]');
    var teamTxt = priceEl ? priceEl.textContent : '';
    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        mode = o.getAttribute('data-mode');
        opts.forEach(function (x) { x.setAttribute('aria-pressed', x === o ? 'true' : 'false'); });
        if (priceEl) {
          var em = o.querySelector('em');
          if (mode === 'lavina' && em) { priceEl.removeAttribute('data-k2-price'); priceEl.textContent = em.textContent; }
          else priceEl.textContent = teamTxt;
        }
      });
    });
    $$('[data-open-book]').forEach(function (b) {
      b.addEventListener('click', function () {
        var dlg = document.getElementById('kds-book'); if (!dlg) return;
        var want = mode === 'lavina' ? 'lavina' : 'team';
        var input = dlg.querySelector('input[name="Healer"][data-mode="' + want + '"]') || (want === 'team' ? dlg.querySelector('input[name="Healer"]:not([data-mode="lavina"])') : null);
        if (input && !input.disabled && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
  }
})();

/* Studio hours: Monday to Saturday, 09:00 to 18:00 IST. The request-only fallback picker (used when live times cannot load)
   and a few booking messages come from kd-studio.js; this brings them in line without touching that file. */
(function () {
  'use strict';
  var dlg = document.getElementById('kds-book');
  var dbox = dlg && dlg.querySelector('[data-dates]'), tbox = dlg && dlg.querySelector('[data-times]');
  if (dbox && tbox) {
    var ist = new Date(Date.now() + (new Date().getTimezoneOffset() + 330) * 60000), d = new Date(ist.getFullYear(), ist.getMonth(), ist.getDate()), out = [];
    d.setDate(d.getDate() + (ist.getHours() >= 16 ? 2 : 1));
    while (out.length < 14) { if (d.getDay() !== 0) out.push(new Date(d)); d.setDate(d.getDate() + 1); }
    dbox.innerHTML = out.map(function (x) {
      var v = x.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      return '<label><input type="radio" name="Date" value="' + v + '"><span><b>' + x.toLocaleDateString('en-GB', { weekday: 'short' }) + '</b><i>' + x.getDate() + '</i><em>' + x.toLocaleDateString('en-GB', { month: 'short' }) + '</em></span></label>';
    }).join('');
    tbox.innerHTML = ['09:00', '10:00', '11:00', '12:00', '14:00', '15:00', '16:00', '17:00'].map(function (t) { return '<label><input type="radio" name="Time" value="' + t + ' IST"><span>' + t + '</span></label>'; }).join('');
  }
  var fix = function (root) {
    if (!root || !document.createTreeWalker) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) if (n.nodeValue.indexOf('Monday to Friday') > -1) n.nodeValue = n.nodeValue.replace(/Monday to Friday, 10:00 to 17:00/g, 'Monday to Saturday, 09:00 to 18:00').replace(/Monday to Friday/g, 'Monday to Saturday');
  };
  fix(dlg);
  if ('MutationObserver' in window) new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes && Array.prototype.forEach.call(m.addedNodes, function (x) { if (x.nodeType === 1 && (x.closest && (x.closest('.kds-manage') || x.closest('#kds-book')))) fix(x); }); }); }).observe(document.body, { childList: true, subtree: true });
})();

/* Open now (28 Sep): during studio hours, Monday to Saturday 09:00 to 18:00 India time, the live chip says the studio is open
   instead of showing the next bookable hour. Outside hours the next open hour from the booking engine shows as before.
   The chip is taken out of kd-studio.js's hands (attribute removed, text span replaced) so the two never race. */
(function () {
  'use strict';
  var st = window.kdStudioOpen && window.kdStudioOpen();
  if (!st) return;
  Array.prototype.forEach.call(document.querySelectorAll('[data-k2-next]'), function (n) {
    n.removeAttribute('data-k2-next');
    var old = n.querySelector('[data-k2-next-text]'), span = document.createElement('span');
    span.textContent = st.label;
    if (old) old.parentNode.replaceChild(span, old); else n.appendChild(span);
    n.classList.add('is-open-now');
    n.hidden = false;
  });
})();
